<template>
  <div :class="flot ? 'describe flot' : 'describe' ">
    <div class="inner">
      <div class="item">
        <div class="title">
          {{ $t('user-productInfo-product/productName') }}
        </div>
        <div class="value">
          {{ describe.name_cn || $t("user-comphonents-describe/no") }}
        </div>
      </div>
      <div class="item">
        <div class="title">
          {{ $t('user-tools/code') }}
        </div>
        <div class="value">
          {{ describe.pi_code || $t("user-comphonents-describe/no") }}
        </div>
      </div>
      <div class="item">
        <div class="title">
          {{ $t('user-tools/status') }}
        </div>
        <div class="value">
          <font color="#ed1c24">
            {{ describe.register_status == 0 ? $t("user-tools/notCompleted") : '' }}
          </font>
          <font color="#ed1c24">
            {{ describe.register_status == 1 ? $t("user-tools/completed") : '' }}
          </font>
          <font color="#ed1c24">
            {{ describe.register_status == 2 ? $t("admin-products-products/shortlisted") : '' }}
          </font>
          <font color="#ed1c24">
            {{ describe.register_status == 3 ? $t("user-tools/success") : '' }}
          </font>
          <font color="#5B9BD5">
            {{ describe.register_status == 4 ? $t("admin-products-products/winning") : '' }}
          </font>
          <font color="#FF0000">
            {{ describe.register_status == 5 ? $t("admin-products-products/silveraward") : '' }}
          </font>
          <font color="#ED7D31">
            {{ describe.register_status == 6 ? $t("admin-products-products/goldaward") : '' }}
          </font>
          <font color="#ff6400">
            {{ describe.register_status == 7 ? '优胜奖' : '' }}
          </font>
          <font color="#ff6400">
            {{ describe.register_status == 8 ? '入围' : '' }}
          </font>
        </div>
      </div>
      <!-- <div class="item">
        <div class="title">
          {{ $t('user-tools/link') }}
        </div>
        <div class="value">
          <font color="#ed1c24">
            xmgcd@xmcci.com
          </font>
        </div>
      </div> -->
      <div class="item">
        <!-- <div class="title">
          {{ $t('user-tools/terms') }}
        </div> -->
        <!-- <div class="value">
          <font color="#ed1c24" style="font-size: 14px;">
            <a
              :href="`javascript: window.open('${request.defaults.baseURL}/storage/pdf/terms-and-conditions.pdf')`"
              style="text-decoration:underline;"
            >{{ $t('user-tools/terms') }}</a>
          </font>
        </div> -->
      </div>
    </div>
  </div>
</template>
<script>
import request from '@/utils/request'

export default {
  props: {
    describe: {
      type: Object,
      default: () => {}
    },
    flot: {
      type: Boolean,
      default: false
    }
  },
  data() {
    return {
      request: request
    }
  },
  created() {
    console.log('flot', this.flot)
  }
}
</script>
<style scoped>
    .flot {
      position: fixed;
      right: 20px;
      top: 15%;
    }
    .describe {
      padding-top: 124px;
    }

    .describe .inner {
      width: 17.29vw;
      background:rgba(255,255,255,1);
      border-radius: 10px;
      padding: 27px 0 15px 27px;
      margin-bottom: 80px;
    }

    .item {
        margin-bottom: 26px;
    }

    .item .title {
        font-size: 14px;
        color: #999999;
    }

    .item .value {
        font-size: 16px;
    }
</style>
